





















import { Cluster } from '@/features/core/store/page-modules/modbus-edit-registers/modbus-edit-register.module';
import { defineComponent } from '@vue/composition-api';
import { mapGetters } from 'vuex';

export default defineComponent<any, Record<string, unknown>, any, any, any>({
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    ...mapGetters([
      'clusterData',
      'activeClusterName',
      'activeControlModelName',
      'activeHeatingSystemClusters',
      'activeHeatingSystemClusterIdx',
    ]),
    filteredClusters(): { name: string }[] {
      return (
        this.activeHeatingSystemClusters.map((cluster: Cluster) => ({
          name: cluster.name,
          idx: cluster.idx,
        })) ?? []
      );
    },
  },
  methods: {
    setActiveCluster(cluster: Cluster) {
      this.$store.commit('setActiveCluster', cluster.name);
      this.$store.commit('setActiveSelectedClusterIdx', cluster.idx);
    },
  },
});
